import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const anomaliThreatStream = defineConnector({
  identifier: "anomaliThreatStream",
  name: "Anomali ThreatStream",
  tagLine: "Threat intelligence platform",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.threatstream\\.com/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        scheme: "apikey",
        value: `${app.config.username}:${app.secret.apiKey}`,
      },
    ]),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to [Anomali ThreatStream](https://ui.threatstream.com/) and open **Settings › My Profile** to find your username and API key.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "configuration", field: "username" },
          helperText:
            "Your ThreatStream account username (usually your email).",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.threatstream.com/api/v2/intelligence/?limit=1",
  },
});
